export default __webpack_public_path__ + "static/media/user.38b09736.png";